"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const layout_1 = __importDefault(require("../components/layout"));
const tomato_1 = __importDefault(require("../chat/tomato"));
const CommonStyle = (0, styled_components_1.createGlobalStyle) `
    @media (max-width: 700px){   
    .widget {
        display: none;
    }
    }
`;
const Widget = styled_components_1.default.section `
    position: absolute;
    right: 10px;
    top: 50%;
    z-index: 999999;
    &:hover {
        
    }
    
`;
const WidgetList = styled_components_1.default.ul `
    list-style: none;
`;
const Main = () => {
    const [container, setContainer] = (0, react_1.useState)('350');
    const handleContainer = (width) => {
        setContainer(width);
    };
    return (react_1.default.createElement(layout_1.default, null,
        react_1.default.createElement(CommonStyle, null),
        react_1.default.createElement(Widget, { className: 'widget' },
            react_1.default.createElement(WidgetList, null,
                react_1.default.createElement("li", null,
                    react_1.default.createElement("h2", null, "container width")),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("span", null,
                        "size: ",
                        container,
                        "px")),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("button", { type: "button", onClick: () => handleContainer('800') }, "800px")),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("button", { type: "button", onClick: () => handleContainer('400') }, "400px")),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("button", { type: "button", onClick: () => handleContainer('350') }, "350px")))),
        react_1.default.createElement("section", { className: "container", style: {
                display: "flex",
                flex: "1",
                maxWidth: `${container}px`,
                maxHeight: "645px"
            } },
            react_1.default.createElement(tomato_1.default, { url: 'https://chatting-serve.herokuapp.com/webChat', imageSize: 5, secretKey: 'goodTomato' }))));
};
exports.default = Main;
